import { render, staticRenderFns } from "./CopyBetgame.vue?vue&type=template&id=3d3d51e2"
import script from "./CopyBetgame.vue?vue&type=script&lang=js"
export * from "./CopyBetgame.vue?vue&type=script&lang=js"
import style0 from "./CopyBetgame.vue?vue&type=style&index=0&id=3d3d51e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports